import * as React from 'react'

import { createStrictContext, useStrictContext } from '@/shared/lib/react'

type TenantColorInversion = {
  isInverted: boolean
}

const TenantColorInversionContext = createStrictContext<TenantColorInversion>('TenantColorInversionContext')

export const TenantColorInversionProvider: React.FC<{ children: React.ReactNode; isInverted: boolean }> = ({
  children,
  isInverted,
}) => {
  const contextValue = React.useMemo((): TenantColorInversion => ({ isInverted }), [isInverted])

  return <TenantColorInversionContext.Provider value={contextValue}>{children}</TenantColorInversionContext.Provider>
}

export const useTenantColorInversion = () => {
  return useStrictContext(TenantColorInversionContext)
}
